import { useEffect, useSyncExternalStore } from 'react'

// platform-account-3: while a sticky save bar shows, desktop toasts rise above it. At the bottom right they covered
// its Save button, and hovering a toast pauses it, so it stayed there.
let saveBars = 0
const listeners = new Set<() => void>()

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function count(change: number) {
  saveBars += change
  listeners.forEach((listener) => listener())
}

/** For sticky bottom save bars: while `shown`, desktop toasts sit above the bar instead of over it. */
export function useLiftToasts(shown: boolean): void {
  useEffect(() => {
    if (!shown) return
    count(1)
    return () => count(-1)
  }, [shown])
}

/** True while a save bar shows (the Toaster lifts its desktop offset). */
export function useToastsLifted(): boolean {
  return useSyncExternalStore(subscribe, () => saveBars > 0, () => false)
}
